import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { IMonitoredAreaRepository } from '../../domain/repositories/IMonitoredArea.repository'
import { IHttpGetMethod } from '../../../@shared/domain/interfaces/IHttpClient.interface'
import { MonitoredArea } from '../../domain/entities/MonitoredArea'
import { MonitoredAreaSchema } from './schemas/MonitoredArea.schema'

export type SkippedMonitoredArea = { index: number; id: unknown; nome: unknown }
export type OnSkippedMonitoredAreas = (skipped: SkippedMonitoredArea[], label: string) => void

// Parse tolerante: descarta itens fora do contrato (ex: geometria com type
// diferente de Polygon/MultiPolygon) em vez de derrubar a lista inteira.
function parseMonitoredAreaList(
	rawData: unknown,
	label: string,
	onSkipped?: OnSkippedMonitoredAreas,
): MonitoredArea[] {
	if (!Array.isArray(rawData)) return []
	const items: MonitoredArea[] = []
	const skipped: SkippedMonitoredArea[] = []
	rawData.forEach((item, index) => {
		const record = item as Record<string, unknown>
		try {
			const result = MonitoredAreaSchema.safeParse(item)
			if (result.success) items.push(result.data)
			else skipped.push({ index, id: record?.id, nome: record?.nome })
		} catch {
			skipped.push({ index, id: record?.id, nome: record?.nome })
		}
	})
	if (skipped.length > 0) {
		console.warn(
			`[MonitoredArea/${label}] ${skipped.length} de ${rawData.length} item(s) descartado(s):`,
			skipped,
		)
		onSkipped?.(skipped, label)
	}
	return items
}

export class MonitoredAreaRepositoryApiAdapter implements IMonitoredAreaRepository {
	private _endpoint = '/v1/area-monitorada'

	constructor(
		private _httpClient: IHttpGetMethod,
		private _onSkipped?: OnSkippedMonitoredAreas,
	) {}

	async getSetted(customerId: string): Promise<MonitoredArea[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-configuradas-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return parseMonitoredAreaList(response.data, 'getSetted', this._onSkipped)
	}

	async getUnsetted(customerId: string): Promise<MonitoredArea[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-nao-configuradas-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return parseMonitoredAreaList(response.data, 'getUnsetted', this._onSkipped)
	}
}
